import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsGridTableWrapper = styled<any, any>(
    'div',
    'documentsGridTableWrapper',
    'documentsGrid'
)`
    ${propStyles};
`;

DocumentsGridTableWrapper.defaultProps = {
    flex: 1,
    overflowY: 'auto',
    paddingX: 'md',
};

export default DocumentsGridTableWrapper;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsGridTableWrapper.tsx